import axiosFetch from './config';

export const getFiadoProducts = async (originCurrency, destinationCurrency="484") => {
    let token = await localStorage.getItem('token')
    return axiosFetch({
        method: "GET",
        url: `/products?input1=${originCurrency}&input2=${destinationCurrency}&component=FIADO`,
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}

export const getFiadoSuscriptions = async (originCurrency, destinationCurrency="484") => {
    let token = await localStorage.getItem('token')
    return axiosFetch({
        method: "GET",
        url: `/products?input1=${originCurrency}&input2=${destinationCurrency}&component=FIADO_SUBSCRIPTIONS`,
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}

export const getPaymentMethods = async (originCurrency, destinationCurrency="484",component='PAYMENT_METHOD') => {
    let token = await localStorage.getItem('token')
    return axiosFetch({
        method: "GET",
        url: `/products?input1=${originCurrency}&input2=${destinationCurrency}&component=${component}`,
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}